import { render, staticRenderFns } from "./livelist.vue?vue&type=template&id=012fcd8d&scoped=true&"
import script from "./livelist.vue?vue&type=script&lang=js&"
export * from "./livelist.vue?vue&type=script&lang=js&"
import style0 from "./livelist.vue?vue&type=style&index=0&id=012fcd8d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012fcd8d",
  null
  
)

export default component.exports